const Icons = {
  check: 'e900',
  checks: 'e901',
  activesessions: 'e902',
  add: 'e903',
  add_chat: 'e904',
  add_reaction: 'e905',
  addboost: 'e906',
  addmember_filled: 'e907',
  adduser: 'e908',
  admin: 'e909',
  ads: 'e90a',
  align_center: 'e90b',
  align_left: 'e90c',
  align_right: 'e90d',
  animals: 'e90e',
  animations: 'e90f',
  app_expand: 'e910',
  app_shrink: 'e911',
  archive: 'e912',
  archive_filled: 'e913',
  arrow_down: 'e914',
  arrow_next: 'e915',
  arrow_prev: 'e916',
  arrow_up_circle_fill: 'e917',
  arrowcircle: 'e918',
  arrowhead: 'e919',
  attach: 'e91a',
  attach_edit: 'e91b',
  audio_repeat: 'e91c',
  audio_repeat_single: 'e91d',
  author_hidden: 'e91e',
  auto_delete_circle_1: 'e91f',
  auto_delete_circle_2: 'e920',
  auto_delete_circle_3: 'e921',
  auto_delete_circle_4: 'e922',
  auto_delete_circle_5: 'e923',
  auto_delete_circle_6: 'e924',
  auto_delete_circle_clock: 'e925',
  auto_delete_circle_days: 'e926',
  auto_delete_circle_empty: 'e927',
  auto_delete_circle_months: 'e928',
  auto_delete_circle_off: 'e929',
  auto_delete_circle_weeks: 'e92a',
  auto_delete_circle_years: 'e92b',
  avatarnext: 'e92c',
  avatarprevious: 'e92d',
  aversion: 'e92e',
  back: 'e92f',
  backward_5: 'e930',
  binfilled: 'e931',
  bold: 'e932',
  bomb: 'e933',
  boost: 'e934',
  boostcircle: 'e935',
  boosts: 'e936',
  bot_filled: 'e937',
  botcom: 'e938',
  bots: 'e939',
  brightness: 'e93a',
  brush: 'e93b',
  bubblereply: 'e93c',
  bug: 'e93d',
  calendar: 'e93e',
  calendarfilter: 'e93f',
  camera: 'e940',
  cameraadd: 'e941',
  captiondown: 'e942',
  captionup: 'e943',
  car: 'e944',
  card: 'e945',
  card_outline: 'e946',
  cash_circle: 'e947',
  channel: 'e948',
  channel_filled: 'e949',
  channelviews: 'e94a',
  chatspinned: 'e94b',
  chatsplaceholder: 'e94c',
  check1: 'e94d',
  checkbox: 'e94e',
  checkboxblock: 'e94f',
  checkboxempty: 'e950',
  checkboxon: 'e951',
  checklist_add: 'e952',
  checklist_done: 'e953',
  checklist_undone: 'e954',
  checkretract: 'e955',
  checkround: 'e956',
  checkround_filled: 'e957',
  clipboard: 'e958',
  clock: 'e959',
  close: 'e95a',
  clouddownload: 'e95b',
  collapse: 'e95c',
  colorize: 'e95d',
  comments: 'e95e',
  commentssticker: 'e95f',
  contrast: 'e960',
  copy: 'e961',
  crop: 'e962',
  cross: 'e963',
  crossgif: 'e964',
  crossround: 'e965',
  crossround_filled: 'e966',
  crossstar: 'e967',
  crown: 'e968',
  crown_outline: 'e969',
  crownalt: 'e96a',
  crownoff: 'e96b',
  crownoff_outline: 'e96c',
  darkmode: 'e96d',
  data: 'e96e',
  delete: 'e96f',
  delete_filled: 'e970',
  deletedaccount: 'e971',
  deleteleft: 'e972',
  deleteuser: 'e973',
  devices: 'e974',
  document: 'e975',
  dollar_circle: 'e976',
  dollar_circle_x: 'e977',
  down: 'e978',
  down_up: 'e979',
  download: 'e97a',
  dragfiles: 'e97b',
  dragmedia: 'e97c',
  eats: 'e97d',
  edit: 'e97e',
  email: 'e97f',
  endcall_filled: 'e980',
  enhance: 'e981',
  enter: 'e982',
  equalizer: 'e983',
  expand: 'e984',
  eye: 'e985',
  eye1: 'e986',
  eye2: 'e987',
  eyecross_outline: 'e988',
  faceid: 'e989',
  factcheck: 'e98a',
  fade: 'e98b',
  fast_forward: 'e98c',
  fast_rewind: 'e98d',
  favourites: 'e98e',
  filter: 'e98f',
  fire: 'e990',
  flag: 'e991',
  flip: 'e992',
  flip_image_horizontal: 'e993',
  folder: 'e994',
  fontframe: 'e995',
  fontframe_bg: 'e996',
  fontframe_outline: 'e997',
  fontsize: 'e998',
  forward: 'e999',
  forward_25: 'e99a',
  forward_filled: 'e99b',
  free_transform: 'e99c',
  fullscreen: 'e99d',
  gc_microphone: 'e99e',
  gc_microphoneoff: 'e99f',
  gem: 'e9a0',
  gem_exchange: 'e9a1',
  gem_transfer: 'e9a2',
  gem_transfer_outline: 'e9a3',
  geometric_digit_0: 'e9a4',
  geometric_digit_1: 'e9a5',
  geometric_digit_2: 'e9a6',
  geometric_digit_3: 'e9a7',
  geometric_digit_4: 'e9a8',
  geometric_digit_5: 'e9a9',
  geometric_digit_6: 'e9aa',
  geometric_digit_7: 'e9ab',
  geometric_digit_8: 'e9ac',
  geometric_digit_9: 'e9ad',
  geometric_dot: 'e9ae',
  geometric_letter_x: 'e9af',
  gifs: 'e9b0',
  gift: 'e9b1',
  gift_premium: 'e9b2',
  grain: 'e9b3',
  group: 'e9b4',
  group_filled: 'e9b5',
  group_star: 'e9b6',
  groupmedia: 'e9b7',
  groupmediaoff: 'e9b8',
  hand: 'e9b9',
  help: 'e9ba',
  hide: 'e9bb',
  highlights: 'e9bc',
  hourglass: 'e9bd',
  image: 'e9be',
  image_original: 'e9bf',
  info: 'e9c0',
  info2: 'e9c1',
  italic: 'e9c2',
  key: 'e9c3',
  keyboard: 'e9c4',
  lamp: 'e9c5',
  language: 'e9c6',
  largepause: 'e9c7',
  largeplay: 'e9c8',
  left: 'e9c9',
  limit_chat: 'e9ca',
  limit_chats: 'e9cb',
  limit_file: 'e9cc',
  limit_folders: 'e9cd',
  limit_link: 'e9ce',
  limit_pin: 'e9cf',
  link: 'e9d0',
  link_paid: 'e9d1',
  list: 'e9d2',
  listscreenshare: 'e9d3',
  livelocation: 'e9d4',
  location: 'e9d5',
  lock: 'e9d6',
  lockoff: 'e9d7',
  loginlogodesktop: 'e9d8',
  loginlogomobile: 'e9d9',
  logout: 'e9da',
  mac_command_key: 'e9db',
  mediaspeed_empty: 'e9dc',
  mediaspoiler: 'e9dd',
  mediaspoileroff: 'e9de',
  mention: 'e9df',
  menu: 'e9e0',
  menu_feature_cover: 'e9e1',
  menu_feature_unique: 'e9e2',
  menu_verification: 'e9e3',
  message: 'e9e4',
  message_jump: 'e9e5',
  message_quote: 'e9e6',
  messageunread: 'e9e7',
  microphone: 'e9e8',
  microphone_crossed: 'e9e9',
  microphone_crossed_filled: 'e9ea',
  microphone_filled: 'e9eb',
  minus: 'e9ec',
  monospace: 'e9ed',
  more: 'e9ee',
  movetochats: 'e9ef',
  movetomenu: 'e9f0',
  multistories: 'e9f1',
  music: 'e9f2',
  mute: 'e9f3',
  muted: 'e9f4',
  mynotes: 'e9f5',
  newchannel: 'e9f6',
  newchannel_filled: 'e9f7',
  newchat_filled: 'e9f8',
  newgroup: 'e9f9',
  newgroup_filled: 'e9fa',
  newprivate: 'e9fb',
  newprivate_filled: 'e9fc',
  newtab: 'e9fd',
  next: 'e9fe',
  nochannel: 'e9ff',
  noncontacts: 'ea00',
  nosound: 'ea01',
  note: 'ea02',
  okay: 'ea03',
  online: 'ea04',
  passwordoff: 'ea05',
  pause: 'ea06',
  permissions: 'ea07',
  person: 'ea08',
  phone: 'ea09',
  phone_filled: 'ea0a',
  pin: 'ea0b',
  pin2: 'ea0c',
  pinlist: 'ea0d',
  pinned_filled: 'ea0e',
  pinnedchat: 'ea0f',
  pip: 'ea10',
  play: 'ea11',
  playback_05: 'ea12',
  playback_15: 'ea13',
  playback_1x: 'ea14',
  playback_2x: 'ea15',
  plus: 'ea16',
  plusround: 'ea17',
  poll: 'ea18',
  premium_addone: 'ea19',
  premium_avatars: 'ea1a',
  premium_badge: 'ea1b',
  premium_colors: 'ea1c',
  premium_double: 'ea1d',
  premium_emoji: 'ea1e',
  premium_filesize: 'ea1f',
  premium_lastseen: 'ea20',
  premium_limits: 'ea21',
  premium_lock: 'ea22',
  premium_management: 'ea23',
  premium_noads: 'ea24',
  premium_privacy: 'ea25',
  premium_reactions: 'ea26',
  premium_restrict: 'ea27',
  premium_speed: 'ea28',
  premium_status: 'ea29',
  premium_stickers: 'ea2a',
  premium_tags: 'ea2b',
  premium_transcription: 'ea2c',
  premium_translate: 'ea2d',
  premium_unlock: 'ea2e',
  premium_wallpaper: 'ea2f',
  previous: 'ea30',
  promote: 'ea31',
  quote: 'ea32',
  quote_outline: 'ea33',
  radiooff: 'ea34',
  radioon: 'ea35',
  reactions: 'ea36',
  reactions_filled: 'ea37',
  readchats: 'ea38',
  recent: 'ea39',
  redo: 'ea3a',
  reload_star: 'ea3b',
  replace: 'ea3c',
  reply: 'ea3d',
  reply_filled: 'ea3e',
  restrict: 'ea3f',
  revenue: 'ea40',
  rightpanel: 'ea41',
  rotate: 'ea42',
  rotate_left: 'ea43',
  rotate_right: 'ea44',
  round_chats_filled: 'ea45',
  saturation: 'ea46',
  saved: 'ea47',
  savedmessages: 'ea48',
  schedule: 'ea49',
  scheduled: 'ea4a',
  search: 'ea4b',
  select: 'ea4c',
  send: 'ea4d',
  send2: 'ea4e',
  sending: 'ea4f',
  sendingerror: 'ea50',
  settings: 'ea51',
  settings_clipped_corner: 'ea52',
  settings_filled: 'ea53',
  shadows: 'ea54',
  sharescreen_filled: 'ea55',
  sharpen: 'ea56',
  shipping: 'ea57',
  shuffle: 'ea58',
  smallscreen: 'ea59',
  smile: 'ea5a',
  sort_date: 'ea5b',
  sort_num: 'ea5c',
  sort_price: 'ea5d',
  speaker: 'ea5e',
  speakerfilled: 'ea5f',
  speakeroff: 'ea60',
  speakerofffilled: 'ea61',
  spoiler: 'ea62',
  sport: 'ea63',
  star: 'ea64',
  star_filled: 'ea65',
  statistics: 'ea66',
  stickers: 'ea67',
  stickers_face: 'ea68',
  stop: 'ea69',
  stories: 'ea6a',
  story: 'ea6b',
  storyreply: 'ea6c',
  storyrepost: 'ea6d',
  strikethrough: 'ea6e',
  suggested: 'ea6f',
  tag: 'ea70',
  tag_add: 'ea71',
  tag_alt: 'ea72',
  tag_alt_crossed: 'ea73',
  tag_alt_outline: 'ea74',
  tag_crossed: 'ea75',
  tag_filter: 'ea76',
  tag_name: 'ea77',
  text: 'ea78',
  textedit: 'ea79',
  time_lock: 'ea7a',
  timer: 'ea7b',
  tip: 'ea7c',
  ton: 'ea7d',
  tools: 'ea7e',
  topics: 'ea7f',
  trade: 'ea80',
  transcribe: 'ea81',
  unarchive: 'ea82',
  unclaimed: 'ea83',
  underline: 'ea84',
  undo: 'ea85',
  unmute: 'ea86',
  unpack: 'ea87',
  unpin: 'ea88',
  unread: 'ea89',
  up: 'ea8a',
  up_down: 'ea8b',
  user: 'ea8c',
  username: 'ea8d',
  videocamera: 'ea8e',
  videocamera_crossed_filled: 'ea8f',
  videocamera_filled: 'ea90',
  videochat: 'ea91',
  vignette: 'ea92',
  volume_down: 'ea93',
  volume_mute: 'ea94',
  volume_off: 'ea95',
  volume_up: 'ea96',
  warmth: 'ea97',
  warning: 'ea98',
  webview: 'ea99',
  win_key: 'ea9a',
  zoomin: 'ea9b',
  zoomout: 'ea9c'
};

export default Icons;
